export const ACTION_AGE_MIN = 13;
export const ACTION_AGE_MAX = 65;

const GENDERS = ["men", "women"];

type AnswerQuota = { gender?: string | null; age_min?: number | null; age_max?: number | null } | null | undefined;

type DetectedAction =
  | { action: "pause_adsets_by_gender"; gender: string }
  | { action: "pause_adsets_by_age_range"; age_min: number; age_max: number };

type BlankableAction = {
  action: string;
  c_campaigns?: unknown[];
  adsets?: unknown[];
  audiences?: unknown[];
};

const clampAge = (age: number): number => Math.min(Math.max(age, ACTION_AGE_MIN), ACTION_AGE_MAX);

const hasAge = (answerQuota: AnswerQuota): boolean => answerQuota?.age_min != null || answerQuota?.age_max != null;

export const detectionLabel = (answerQuota: AnswerQuota): string | null => {
  const parts: string[] = [];
  if (answerQuota?.gender && GENDERS.includes(answerQuota.gender)) parts.push(answerQuota.gender);
  if (hasAge(answerQuota)) parts.push(`${answerQuota?.age_min ?? "?"}–${answerQuota?.age_max ?? "?"}`);
  return parts.length ? parts.join(", ") : null;
};

export const actionFromDetection = (answerQuota: AnswerQuota): DetectedAction | null => {
  if (answerQuota?.gender && GENDERS.includes(answerQuota.gender)) {
    return { action: "pause_adsets_by_gender", gender: answerQuota.gender };
  }
  if (!hasAge(answerQuota)) return null;

  const ageMin = answerQuota?.age_min ?? ACTION_AGE_MIN;
  const ageMax = answerQuota?.age_max ?? ACTION_AGE_MAX;
  if (ageMax < ACTION_AGE_MIN || ageMin > ACTION_AGE_MAX) return null;
  return { action: "pause_adsets_by_age_range", age_min: clampAge(ageMin), age_max: clampAge(ageMax) };
};

export const isBlankAction = (action: BlankableAction): boolean =>
  action.action === "pause_adsets" &&
  !action.c_campaigns?.length &&
  !action.adsets?.length &&
  !action.audiences?.length;
